"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'currency.error.missingCurrencyCode': 'Currency code is required',
    'currency.error.failedToGetRate': 'Failed to get currency rate',
    'currency.error.missingConversionParams': 'From currency, to currency, and amount are required',
    'currency.error.invalidAmount': 'Amount must be a positive number',
    'currency.error.failedToConvert': 'Failed to convert currency',
    'currency.error.failedToGetCurrencies': 'Failed to get currency list',
    'currency.error.failedToGetSupportedCurrencies': 'Failed to get supported currencies',
    'currency.error.missingHistoricalParams': 'Currency code, start date, and end date are required',
    'currency.error.invalidDateFormat': 'Date format must be YYYY-MM-DD',
    'currency.error.failedToGetHistoricalRates': 'Failed to get historical rates',
    'currency.error.failedToGetGoldPrice': 'Failed to get gold price',
};
